import React, { useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Container } from "react-bootstrap";
import { ClientNameContext } from "../contexts/clientNameContext";
import { CartContext } from "../contexts/CartContext";
import { useTranslation } from 'react-i18next';

function LogoutScreen({ isLoggedOut }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setClientName } = useContext(ClientNameContext);
  const { setCart } = useContext(CartContext);

  const [showAlert, setShowAlert] = useState(false);

  const clearData = useCallback(() => {
    localStorage.removeItem("clientName");
    localStorage.removeItem("clientId");
    localStorage.removeItem("clientSurname");
    localStorage.removeItem("clientEmail");

    localStorage.clear();

    setClientName("");
    setCart([]);

    setShowAlert(true);
  }, [setClientName, setCart]);

  useEffect(() => {
    clearData();
    navigate("/logout");
  }, [navigate, clearData]);

  return (
    <Container>
      {showAlert && (
        <Alert
          variant="success"
          onClose={() => setShowAlert(false)}
          dismissible
          className="mt-4"
        >
          {t('logout_success')}
        </Alert>
      )}
    </Container>
  );
}

export default LogoutScreen;
